@if (!payments) {
  <section>
    <div class="header">
      <h1>{{ 'PAYMENT.BG_MAX_IMPORT' | translate }}</h1>
    </div>
    <form (ngSubmit)="onSubmit()">
      <div class="form-group">
        <input type="file" (change)="onChange($event.target.files)" />
      </div>
      <div>
        <button class="btn btn-outlined" type="submit" [disabled]="processing">{{ 'IMPORT_BTN' | translate }}</button>
      </div>
    </form>
  </section>
}
@if (payments) {
  <section>
    <h1 class="header list-header">{{ 'PAYMENT.PAYMENTS_TO_SAVE' | translate }}</h1>
    <app-list-view
      [columnDefinition]="columnDefinition"
      [itemsSource]="payments"
      [preferencesKey]="'invoice.bg-max-import.payments'"
    ></app-list-view>
    <div>
      <button class="btn btn-outlined" type="button" (click)="save()" [disabled]="processing">{{ 'SAVE_BTN' | translate }}</button>
      <button class="btn btn-outlined ml-2" type="button" (click)="cancel()" [disabled]="processing">{{ 'CANCEL_BTN' | translate }}</button>
    </div>
  </section>
}
